/* unplugin-vue-components disabled */import { render } from "./SideBarItem.vue?vue&type=template&id=9a1ad402&scoped=true"
import script from "./SideBarItem.vue?vue&type=script&lang=js"
export * from "./SideBarItem.vue?vue&type=script&lang=js"

import "./SideBarItem.vue?vue&type=style&index=0&id=9a1ad402&lang=scss&scoped=true"

import exportComponent from "E:\\projects\\internation-fta-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a1ad402"]])

export default __exports__